import { type AxiosRequestConfig } from 'axios';

import { toQueryString } from '@common/utils/toQueryString';

export const buildQueryKey = (
  baseKey: string,
  queryParams?: AxiosRequestConfig['params'],
) => {
  const query = toQueryString(queryParams);

  return query ? `${baseKey}-${query}` : baseKey;
};
